import massuploadService from "src/services/massuploadService";

export const MASSUPLOAD_REQUEST = "@massupload/massupload-request";
export const MASSUPLOAD_SUCCESS = "@massupload/massupload-success";
export const MASSUPLOAD_FAILURE = "@massupload/massupload-failure";

export const MASSUPLOAD_HISTORY_REQUEST = "@massupload/massupload-history-request";
export const MASSUPLOAD_HISTORY_SUCCESS = "@massupload/massupload-history-success";
export const MASSUPLOAD_HISTORY_FAILURE = "@massupload/massupload-history-failure";

export const MASSUPLOAD_CLEAR = "@massupload/massupload-clear";

export function update(data) {
  return async (dispatch) => {
    try {
      dispatch({type: MASSUPLOAD_REQUEST});
      const response = await massuploadService.update(data);
      dispatch({
        type: MASSUPLOAD_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: MASSUPLOAD_FAILURE});
      throw error;
    }
  };
}

export function upload(data) {
  return async (dispatch) => {
    try {
      dispatch({type: MASSUPLOAD_REQUEST});
      const response = await massuploadService.upload(data);
      dispatch({
        type: MASSUPLOAD_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: MASSUPLOAD_FAILURE});
      throw error;
    }
  };
}

export function getMassUploadHistory(data) {
  return async (dispatch) => {
    try {
      dispatch({type: MASSUPLOAD_HISTORY_REQUEST});
      const response = await massuploadService.getMassUploadHistory(data);
      dispatch({
        type: MASSUPLOAD_HISTORY_SUCCESS,
        payload: {
          response: response.data,
          total: response.total_items
        }
      });
    } catch (error) {
      dispatch({type: MASSUPLOAD_HISTORY_FAILURE});
      throw error;
    }
  };
}

export function clearResponse() {
  return async (dispatch) => {
    try {
      dispatch({type: MASSUPLOAD_CLEAR});
    } catch (error) {
      dispatch({type: MASSUPLOAD_FAILURE});
      throw error;
    }
  };
}
